module.exports = __webpack_public_path__ + "static/media/Prata.153ccbe0.svg";